import type { BannerItem } from '@/types'
import Link from 'next/link'
import { type FC } from 'react'
import Slider from 'react-slick'
import ImageOptimize from '../ImageOptimize'
interface Props {
  sliders?: Array<BannerItem>
}
export const LoginSlider: FC<Props> = ({ sliders }: Props) => {
  return (
    <div className={``}>
      <div>
        <Slider className='max-w-screen flex'>
          {sliders &&
            sliders.map((slider: BannerItem, index: number) => (
              <Link href={slider.link || '/'} key={index}>
                <ImageOptimize
                  className='w-full object-cover'
                  src={slider.image}
                  alt={slider.title}
                  width={1366}
                  quality={100}
                  height={717}
                />
              </Link>
            ))}
        </Slider>
      </div>
    </div>
  )
}
